"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconContainer = _interopRequireDefault(require("../IconContainer"));

var _typography = require("../typography");

var _ButtonContainer = _interopRequireDefault(require("./ButtonContainer"));

var _Spinner = require("../Spinner");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var disabled = _ref.disabled,
      loading = _ref.loading,
      Icon = _ref.icon,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["disabled", "loading", "icon", "children"]);

  return _react.default.createElement(_ButtonContainer.default, _extends({
    loading: loading ? 'loading' : '',
    disabled: disabled || !!loading
  }, props, {
    hasText: !!children
  }), loading && _react.default.createElement(_Spinner.Spinner, {
    type: "indeterminate"
  }), Icon && _react.default.createElement(_IconContainer.default, {
    hasText: !!children
  }, _react.default.createElement(Icon, null)), children && _react.default.createElement(_typography.Body, null, children));
};

var _default = Button;
exports.default = _default;